import { css } from 'linaria';

export const phoneClass = css`
  margin-top: var(--space-150);
  color: var(--text-primary);
`;
